<app-dialog-container
  [title]="'selectDraftOrder'"
  [showConfirmButton]="false"
  [showCancelButton]="true"
>
  <div class="cart-draft-picker">
    <app-ui-input
      class="cart-draft-picker-search"
      [label]="'search' | translate"
      [control]="searchControl"
      [showClearButton]="true"
    ></app-ui-input>

    @if (loading) {
      <div class="cart-draft-picker-state">{{ 'loading' | translate }}</div>
    } @else if (draftOrders.length === 0) {
      <div class="cart-draft-picker-state">{{ 'noDraftOrdersFound' | translate }}</div>
    } @else {
      <div class="cart-draft-list">
        <div class="cart-draft-list-header">
          <span>{{ 'orderTitle' | translate }}</span>
          <span>{{ 'orderType' | translate }}</span>
          <span>{{ 'supplier' | translate }}</span>
          <span>{{ 'updated' | translate }}</span>
        </div>
        @for (order of draftOrders; track order.id) {
          <button type="button" class="cart-draft-row" (click)="selectDraft(order)">
            <span class="cart-draft-title">{{ order.title || '-' }}</span>
            <span>{{ order.orderType?.name || '-' }}</span>
            <span>{{ order.supplier?.name || '-' }}</span>
            <span>{{ $any(order).updated || $any(order).created | date }}</span>
          </button>
        }
      </div>
    }
  </div>
</app-dialog-container>
